import Vue from 'vue';
import Vuex from 'vuex';
import * as User from '../models/user';

// Import different modules
import account from './modules/account/store';
import topic from './modules/topic/store';
import configuration from './modules/configuration/store';
import wizard from './modules/wizard/store';
import photo from './modules/photo/store';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState()],

    modules: {
        // All modules
        account,
        topic,
        configuration,
        photo,
        wizard,
    },
});
